/**
 * lazy — code-splitting boundary for the CAD viewer dependency graph.
 *
 * The CAD viewers pull in `three` (~700 KB ungz) + `dxf-viewer` (~150 KB
 * + a web-worker DXF parser) + `three-stdlib` (~50 KB for STLLoader).
 * That graph weighs > 1 MB compressed and must NEVER land in the main
 * bundle — only the dashboard's structured-data CAD panel actually
 * needs it, and most sessions never open one.
 *
 * Mirrors `packages/ui/src/charts/lazy.ts` exactly: a thin React.lazy
 * wrapper around the heavy inner module. The outer shell
 * (`CadViewerSwitch`) renders a `<Suspense>` around this and supplies
 * the Skeleton fallback — so the layout reserves the canvas's space
 * while the chunk downloads and the page doesn't shift on arrival.
 */

import * as React from "react";

export const CadViewerImplLazy = React.lazy(() => import("./CadViewerImpl.js"));
